import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useWorkspace } from '@/api/workspace'
import { SalesChannelForm } from '@/components/sales-channels/sales-channel-form'

// Sales Channel create (UI-SCREENS S-02, #169). Owner only; the API refuses Staff too.
export const Route = createFileRoute('/w/$slug/channels/new')({
  component: NewSalesChannel,
  staticData: { breadcrumb: 'salesChannels.form.newTitle' },
})

function NewSalesChannel() {
  const { t } = useTranslation()
  const { slug } = Route.useParams()
  const workspace = useWorkspace(slug)

  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/channels" params={{ slug }} replace />
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('salesChannels.form.newTitle')}</h1>
      <SalesChannelForm slug={slug} />
    </section>
  )
}
